import BaseSobrevivenciaRequest from "../BaseSobrevivenciaRequest"; 

export default class UbigeoRequest extends BaseSobrevivenciaRequest {
  constructor( 
    public canal: string = "PortalBE",
    public codUsuario: string = "",
    public numPreSolicitud: number= 0, 
    public tipo : string = "",
    public query : string=""
  ) {
    super(canal, codUsuario, numPreSolicitud);
  }
}
